import { AllGameSettings } from "./types";

import { clashofclans } from "./clash-of-clans";
import { brawlstars } from "./brawl-stars";
import { squadbusters } from "./squad-busters";
import { hayday } from "./hayday";
import { clashroyale } from "./clash-royale";
import { rogue } from "./rogue";
import { boombeach } from "./boom-beach";

export const gameSettings: AllGameSettings = {
  squadbusters,
  brawlstars,
  hayday,
  clashroyale,
  clashofclans,
  rogue,
  boombeach,
};

export type { GameSettings, GameResolution, TargetingField } from "./types";
export { targetingFields } from "./types";
